import { Badge } from '@/components/ds2'
import { formatTimeAgo } from '@/utils/format-relative-time'
import { fmtDateTime, toDate } from '../utils/format'

type LocationFreshness = 'success' | 'warning' | 'danger'

interface BoxTruckLocationAgeBadgeProps {
    fixAt?: string | null
}

const RECENT_LOCATION_MAX_AGE_MIN = 30
const AGING_LOCATION_MAX_AGE_MIN = 6 * 60

/** Match the location freshness levels used throughout Box Truck driver views. */
const locationFreshness = (fixAt: Date): LocationFreshness => {
    const ageMin = (Date.now() - fixAt.getTime()) / 60000
    if (ageMin < RECENT_LOCATION_MAX_AGE_MIN) return 'success'
    if (ageMin < AGING_LOCATION_MAX_AGE_MIN) return 'warning'
    return 'danger'
}

/** One shared location-age badge for My Drivers and Nearby Drivers. */
export const BoxTruckLocationAgeBadge = ({ fixAt }: BoxTruckLocationAgeBadgeProps) => {
    const capturedAt = toDate(fixAt)
    if (!capturedAt) {
        return (
            <span className="text-[10px] leading-tight text-foreground-muted" title={fixAt ? 'Location timestamp unavailable' : 'Never shared a location'}>
                —
            </span>
        )
    }

    return (
        <span title={fmtDateTime(capturedAt)}>
            <Badge
                variant="soft"
                type={locationFreshness(capturedAt)}
                size="sm"
                prefix={<span className="h-1.5 w-1.5 rounded-full bg-current" />}
                label={formatTimeAgo(capturedAt)}
                className="font-semibold uppercase tracking-wide"
            />
        </span>
    )
}
